import { Avatar, Box, keyframes, SxProps, Theme } from "@mui/material";
import { ResponsiveStyleValue } from "@mui/system";
import avatarString from "@rf-helper/avatarString";
import { memo, useState } from "react";

export interface BlurredBackgroundImageProps {
  src?: string;
  alt?: string;
  blurAmount?: number;
  width?:
    | string
    | number
    | ResponsiveStyleValue<any>
    | ((theme: Theme) => ResponsiveStyleValue<any>);
  height?:
    | string
    | number
    | ResponsiveStyleValue<any>
    | ((theme: Theme) => ResponsiveStyleValue<any>);
  objectFit?: "contain" | "cover" | "fill";
  borderRadius?: string | number;
  sizeLetter?: number;
  id?: string;
}

const MxImageBlur = memo(
  ({
    src,
    alt = "Image",
    width = "100%",
    height = "100%",
    objectFit = "contain",
    borderRadius = 0,
    sizeLetter = 1,
    id = ""
  }: BlurredBackgroundImageProps) => {
    const [imgError, setImgError] = useState(false);
    const nameAvatar = avatarString(alt || "U");

    const firstLetter = nameAvatar.charAt(0).toUpperCase();
    const secondLetter = nameAvatar.charAt(1).toUpperCase();

    const handleImgError = () => {
      setImgError(true);
    };

    return (
      <Box
        sx={{
          position: "relative",
          width,
          height,
          overflow: "hidden",
          borderRadius
        }}
      >
        {src && !imgError ? (
          <Box
            id={id}
            component="img"
            src={src}
            alt={alt}
            loading="lazy"
            decoding="async"
            onError={handleImgError}
            sx={{
              position: "relative",
              width: "100%",
              height: "100%",
              objectFit,
              zIndex: 1
            }}
          />
        ) : (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#f5f5f5"
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: `${sizeLetter}rem`,
                fontWeight: "bold",
                "& span:nth-of-type(1)": {
                  color: "#1b5596"
                },
                "& span:nth-of-type(2)": {
                  color: "#2a6dba"
                }
              }}
            >
              <span>{firstLetter}</span>
              <span>{secondLetter}</span>
            </Box>
          </Box>
        )}
      </Box>
    );
  }
);

export default MxImageBlur;
